// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {
  Intersect,
  Ripple,
} from 'vuetify/lib/directives';
// import colors from 'vuetify/lib/util/colors'

// import 'vuetify/dist/vuetify.min.css';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify, {
  directives: {
    Intersect,
    Ripple,
  },
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    themes: {
      light: {
        primary: '#91b509',
        secondary: '#0098dd',
        link: '#1976D2',
        'new-primary': '#8CC63F',
        'new-secondary': '#00ABE5',
        'new-black': '#343434',
        'dark-primary': '#2C8C63',
        'new-blue': '#0f6889',
        'health-info-primary': '#6BC629',
        'health-info-secondary': '#076788',
        'secretary-accent': '#FFC107',
        'gamification-300': '#1E3A8A',
        'gamification-200': '#1D4ED8',
        'gamification-100': '#2B7FFF',
        // danger: colors.red.lighten2,
        // accent: '#8c9eff',
        // error: '#b71c1c',
      },
    },
  },
});
